module.exports = __webpack_public_path__ + "static/sm-postmark-alternatives-og-087120c1b9d57ff5e27bc31218ef54e6.jpg";